'use strict';
import * as $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigationItem$002ejs from "@ui5/webcomponents-fiori/dist/SideNavigationItem.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$() {
  this.Dj = null;
  this.Dk = false;
  this.Di = null;
  $n_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigationItem$002ejs.default;
  this.Di = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-side-navigation-item", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ as $c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ as $h_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ };
$h_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.uE = (function() {
  if ((!this.Dk)) {
    this.Dj = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "text", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Dk = true;
  }
  return this.Dj;
});
$p.ec = (function() {
  return this.Di;
});
var $d_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$, "be.doeraene.webcomponents.ui5.SideNavigationItem$", ({
  gq: 1,
  ar: 1,
  cI: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ as $d_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ };
var $n_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$;
function $m_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$)) {
    $n_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ = new $c_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ as $m_Lbe_doeraene_webcomponents_ui5_SideNavigationItem$ };
